import { zeroAddress } from 'viem'
import { cleanAddress } from '../../addresses'
import abi from './abi'

export const UniswapV2USDC = {
  abi,
  address: {
    1: cleanAddress('0xb4e16d0168e52d35cacd2c6185b44281ec28c9dc'),
    11155111: cleanAddress(zeroAddress),
    10: cleanAddress(zeroAddress),
    7777777: cleanAddress(zeroAddress),
    8453: cleanAddress(zeroAddress),
    84532: cleanAddress(zeroAddress),
    999999999: cleanAddress(zeroAddress),
    42161: cleanAddress(zeroAddress),
  } as const,
} as const
